<template>
  <div class="importInvestmens">
    <v-form class="mt-4">
      <v-row>
        <v-col cols="4">
          <div>
            <v-select
              v-model="importType"
              :items="importTypesList"
              item-value="Value"
              item-text="Text"
              label="Import type"
              outlined
              dense
            ></v-select>
          </div>
          <div>
            <v-select
              v-model="importName"
              :items="importNameList"
              item-value="Value"
              item-text="Text"
              label="Import name"
              outlined
              dense
            ></v-select>
          </div>
          <div v-if="importType === 'Monthly Payroll'">
            <v-select
              v-model="currency"
              :items="currencyList"
              label="Currency"
              outlined
              dense
            ></v-select>
          </div>
          <div v-if="importType === 'Monthly Payroll'">
            <v-text-field
              v-model="exchangeRate"
              type="number"
              step="0.0001"
              label="Exchange rate"
              outlined
              dense
            ></v-text-field>
          </div>
          <div>
            <DatePicker v-model="payrollDate" label="Payroll date" />
          </div>
          <div>
            <v-file-input
              v-model="importFiles"
              ref="file"
              label="Import file"
              accept=".csv, text/plain, .tab"
              dense
            ></v-file-input>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-footer padless fixed outlined class="pl-5 pr-5" color="white" elevation="3">
      <v-spacer></v-spacer>
      <div class="btnsContainer">
        <v-btn depressed color="primary" @click="onNext">Next</v-btn>
      </div>
    </v-footer>
  </div>
</template>

<script>
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  name: 'ImportInvestmens',
  components: { DatePicker },
  props: {},
  data: () => ({
    loading: false,
    importTypesList: [],
    importType: null,
    importNameList: [],
    importName: null,
    payrollDate: null,
    importFiles: null,
    currencyList: ['JM', 'CHY', 'EUR', 'GBP', 'RIM', 'USD'],
    currency: 'EUR',
    exchangeRate: '1.0000',
    fileData: null,
  }),

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },

  watch: {
    importType(newValue) {
      this.getImportDefinitionList(newValue);
    },
  },

  created() {
    this.getImportTypesList();
  },

  methods: {
    onNext() {
      var myFile = this.importFiles;
      console.log(myFile);
      console.log(this.importFiles);
      let data = new FormData();
      data.append('PlanId', this.currentPlanId);
      data.append('ImportType', this.importType);
      data.append('ImportId', this.importName);
      console.log(this.importName);
      data.append(
        'ImportName',
        this.importNameList.find((name) => name.Value === this.importName).Text
      );
      data.append('PayrollDate', this.payrollDate);
      data.append('Currency', this.currency);
      data.append('ExchangeRate', this.exchangeRate);
      data.append('File', myFile);
      console.log(data);

      this.startImport(data);
    },

    readFile() {
      // console.log(val);
      // console.log(this.$refs.file);
      // console.log(this.$refs.file.files);
      // console.log(this.importFile);
      // const reader = new FileReader();
      // reader.readAsArrayBuffer(this.importFile);
      // reader.onload = function () {
      //   console.log(reader.result);
      //   this.fileData = reader.result;
      // };
    },

    async getImportTypesList() {
      this.loading = true;
      try {
        const response = await this.$api.get('/Import/GetImportTypes');
        if (response.status !== 200 || !response.data)
          throw new Error('Unable to get import types');
        this.importTypesList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async getImportDefinitionList(importType) {
      try {
        const response = await this.$api.get(
          `/Import/GetImportDefinitionList?planId=${this.currentPlanId}&importType=${importType}`
        );
        if (response.status !== 200 || !response.data)
          throw new Error('Unable to get import definitions');
        this.importNameList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async startImport(importData) {
      this.loading = true;
      console.log(importData);
      try {
        const response = await this.$api.post('/Import/StartImport', importData);
        if (response.status !== 200 || !response.data)
          throw new Error('Unable to process new import');
        console.log(response.data);
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.importInvestmens {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>
